import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/logo.png'


const _hoisted_1 = { class: "page-content" }
const _hoisted_2 = { class: "link-list" }
const _hoisted_3 = { class: "link-item" }
const _hoisted_4 = { class: "link-item" }
const _hoisted_5 = { class: "link-item" }
const _hoisted_6 = { class: "link-item" }

import CustomTitleBar from "@/components/CustomTitleBar/index.vue";
import { onMounted } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

onMounted(() => { })

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomTitleBar, { title: "关于我们" }),
    _createElementVNode("div", _hoisted_1, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "logo-section" }, [
        _createElementVNode("img", {
          src: _imports_0,
          class: "app-logo"
        }),
        _createElementVNode("div", { class: "version" }, "版本号: 1.3.8")
      ], -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[0] || (_cache[0] = _createElementVNode("span", null, "用户协议", -1)),
          _createVNode(_component_van_icon, { name: "arrow" })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("span", null, "隐私政策", -1)),
          _createVNode(_component_van_icon, { name: "arrow" })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[2] || (_cache[2] = _createElementVNode("span", null, "版本更新", -1)),
          _createVNode(_component_van_icon, { name: "arrow" })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _cache[3] || (_cache[3] = _createElementVNode("span", null, "儿童个人信息保护政策", -1)),
          _createVNode(_component_van_icon, { name: "arrow" })
        ])
      ]),
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "copyright" }, [
        _createElementVNode("p", null, "海南梦与前方科技有限公司 版权所有"),
        _createElementVNode("p", null, "Copyright © 2023 JingBao. All Right Reserved.")
      ], -1))
    ])
  ], 64))
}
}

})